/* RareRuns theme.js
   Handles: mobile nav, search dropdown, accordions, login modal, toast,
   policy tabs, Shopify AJAX cart (add + count refresh).
*/
(function () {
  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => (ctx || document).querySelectorAll(sel);

  /* ────────── TOAST ────────── */
  const toastEl = $('#toast');
  let toastTimer;
  function toast(msg, opts) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    // Click-to-cart when toast is "add to cart" notification
    if (opts && opts.linkToCart) {
      toastEl.style.cursor = 'pointer';
      toastEl.onclick = () => { window.location.href = '/cart'; };
    } else {
      toastEl.style.cursor = '';
      toastEl.onclick = null;
    }
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {
      toastEl.classList.remove('show');
      toastEl.style.cursor = '';
      toastEl.onclick = null;
    }, 3200);
  }

  /* ────────── CART (Shopify AJAX) ────────── */
  const cartCountEl = $('#cart-count');
  const cartBtn = $('#cart-btn');

  function updateCartCount(count) {
    if (!cartCountEl) return;
    cartCountEl.textContent = count;
    if (count > 0) cartCountEl.classList.add('visible');
    else cartCountEl.classList.remove('visible');
    cartCountEl.classList.remove('bump');
    void cartCountEl.offsetWidth;
    cartCountEl.classList.add('bump');
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(r => r.json())
      .then(cart => {
        updateCartCount(cart.item_count);
        return cart;
      })
      .catch(() => {});
  }

  function addToCart(variantId, qty, productLabel, btn) {
    if (!variantId) {
      toast('Item unavailable');
      return Promise.reject();
    }
    if (btn) btn.disabled = true;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    })
      .then(r => r.json())
      .then(() => refreshCart())
      .then(cart => {
        toast(`Added ${productLabel || 'item'} to cart — tap to view`, { linkToCart: true });
        if (btn) {
          const orig = btn.textContent;
          btn.classList.add('added');
          btn.textContent = 'Added ✓';
          setTimeout(() => {
            btn.classList.remove('added');
            btn.textContent = orig;
            btn.disabled = false;
          }, 1600);
        }
        return cart;
      })
      .catch(err => {
        toast('Could not add to cart');
        if (btn) btn.disabled = false;
        throw err;
      });
  }

  // Wire any element with [data-add-to-cart][data-variant-id]
  function bindAddButtons(root) {
    (root || document).querySelectorAll('[data-add-to-cart]').forEach(btn => {
      if (btn.dataset.bound) return;
      btn.dataset.bound = 'true';
      btn.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        const variantId = btn.dataset.variantId;
        const qty = parseInt(btn.dataset.quantity, 10) || 1;
        const label = btn.dataset.product || 'item';
        addToCart(variantId, qty, label, btn);
      });
    });
    // Buy now: add to cart, then jump straight to /checkout
    (root || document).querySelectorAll('[data-buy-now]').forEach(btn => {
      if (btn.dataset.bound) return;
      btn.dataset.bound = 'true';
      btn.addEventListener('click', e => {
        e.preventDefault();
        const variantId = btn.dataset.variantId;
        const qty = parseInt(btn.dataset.quantity, 10) || 1;
        const label = btn.dataset.product || 'item';
        const originalText = btn.textContent.trim();
        btn.disabled = true;
        btn.textContent = 'Loading…';
        addToCart(variantId, qty, label, null)
          .then(() => { window.location.href = '/checkout'; })
          .catch(() => { btn.disabled = false; btn.textContent = originalText; });
      });
    });
  }

  // Cart button
  if (cartBtn) {
    cartBtn.addEventListener('click', e => {
      // Default: go to /cart page
      window.location.href = '/cart';
    });
  }

  // Initial cart count
  refreshCart();

  /* ────────── MOBILE NAV / SEARCH ────────── */
  const navHamburger = $('#nav-hamburger');
  const navSearchIcon = $('#nav-search-icon');
  const mobileMenuEl = $('#mobile-menu');
  const mobileMenuCloseBtn = $('#mobile-menu-close');
  const mobileSearchOverlay = $('#mobile-search-overlay');
  const mobileSearchCloseBtn = $('#mobile-search-close');
  const mobileSearchInput = $('#mobile-search-input');
  const mobileSearchForm = $('#mobile-search-form');

  function openMobileMenu() {
    if (!mobileMenuEl) return;
    mobileMenuEl.classList.add('open');
    mobileMenuEl.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileMenu() {
    if (!mobileMenuEl) return;
    mobileMenuEl.classList.remove('open');
    mobileMenuEl.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  function openMobileSearch() {
    if (!mobileSearchOverlay) return;
    mobileSearchOverlay.classList.add('open');
    mobileSearchOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => mobileSearchInput && mobileSearchInput.focus(), 80);
  }
  function closeMobileSearch() {
    if (!mobileSearchOverlay) return;
    mobileSearchOverlay.classList.remove('open');
    mobileSearchOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  navHamburger && navHamburger.addEventListener('click', openMobileMenu);
  navSearchIcon && navSearchIcon.addEventListener('click', openMobileSearch);
  mobileMenuCloseBtn && mobileMenuCloseBtn.addEventListener('click', closeMobileMenu);
  mobileSearchCloseBtn && mobileSearchCloseBtn.addEventListener('click', closeMobileSearch);
  mobileSearchOverlay && mobileSearchOverlay.addEventListener('click', e => {
    if (e.target === mobileSearchOverlay) closeMobileSearch();
  });
  mobileMenuEl && mobileMenuEl.addEventListener('click', e => {
    if (e.target.closest('a')) closeMobileMenu();
  });
  mobileSearchForm && mobileSearchForm.addEventListener('submit', e => {
    e.preventDefault();
    const q = mobileSearchInput.value.trim();
    if (q) {
      window.location.href = `/search?q=${encodeURIComponent(q)}&type=product`;
    }
  });

  /* ────────── DESKTOP SEARCH AUTOCOMPLETE (Shopify Predictive Search) ────────── */
  const searchInput = $('#search-input');
  const searchForm = $('#search-form');
  const dropdown = $('#search-dropdown');

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]));
  }

  let predictiveTimer;
  function predictiveSearch(q) {
    if (!dropdown) return;
    if (!q) { dropdown.classList.remove('open'); return; }
    clearTimeout(predictiveTimer);
    predictiveTimer = setTimeout(() => {
      fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6`, {
        headers: { Accept: 'application/json' }
      })
        .then(r => r.json())
        .then(json => {
          const products = (json.resources && json.resources.results && json.resources.results.products) || [];
          const collections = (json.resources && json.resources.results && json.resources.results.collections) || [];
          if (!products.length && !collections.length) {
            dropdown.innerHTML = `<div class="sr-empty">No matches for <strong>"${escapeHtml(q)}"</strong><br><span style="font-size:12px;">Press Enter to search anyway.</span></div>`;
            dropdown.classList.add('open');
            return;
          }
          let html = '';
          if (products.length) {
            html += `<div class="sr-group"><div class="sr-head">Models</div>`;
            products.forEach(p => {
              html += `<a class="sr-item" href="${p.url}">
                <div class="sr-item-name">${escapeHtml(p.title)}</div>
              </a>`;
            });
            html += `</div>`;
          }
          if (collections.length) {
            html += `<div class="sr-group"><div class="sr-head">Collections</div>`;
            collections.forEach(c => {
              html += `<a class="sr-item" href="${c.url}">
                <div class="sr-item-name">${escapeHtml(c.title)}</div>
              </a>`;
            });
            html += `</div>`;
          }
          dropdown.innerHTML = html;
          dropdown.classList.add('open');
        })
        .catch(() => { dropdown.classList.remove('open'); });
    }, 140);
  }

  if (searchInput) {
    searchInput.addEventListener('input', e => predictiveSearch(e.target.value));
    searchInput.addEventListener('focus', e => { if (e.target.value) predictiveSearch(e.target.value); });
  }
  if (searchForm) {
    searchForm.addEventListener('submit', e => {
      e.preventDefault();
      const q = searchInput.value.trim();
      if (q) window.location.href = `/search?q=${encodeURIComponent(q)}&type=product`;
    });
  }
  document.addEventListener('click', e => {
    if (!e.target.closest('.search-wrap') && dropdown) dropdown.classList.remove('open');
  });

  /* ────────── LOGIN — redirect to Shopify's hosted login page (passwordless) ────────── */
  const loginModal = $('#login-modal');
  const loginBtn = $('#login-btn');
  const loginBtnMobileHeader = $('#login-btn-mobile');
  const mobileLoginBtn = $('#mobile-login');

  function goToShopifyLogin(e) {
    if (e) e.preventDefault();
    window.location.href = '/account/login';
  }
  // Kept for backwards compatibility — these are no-ops now
  function closeLoginModal() { if (loginModal) loginModal.classList.remove('open'); }

  loginBtn && loginBtn.addEventListener('click', goToShopifyLogin);
  loginBtnMobileHeader && loginBtnMobileHeader.addEventListener('click', goToShopifyLogin);

  /* ────────── MOBILE SEARCH PLACEHOLDER ────────── */
  const searchInputEl = $('#search-input');
  if (searchInputEl) {
    const desktopPlaceholder = searchInputEl.getAttribute('placeholder') || '';
    const mobilePlaceholder = 'Search';
    function syncPlaceholder() {
      searchInputEl.setAttribute(
        'placeholder',
        window.matchMedia('(max-width: 1024px)').matches ? mobilePlaceholder : desktopPlaceholder
      );
    }
    syncPlaceholder();
    window.addEventListener('resize', syncPlaceholder);
  }
  mobileLoginBtn && mobileLoginBtn.addEventListener('click', e => {
    e.preventDefault();
    closeMobileMenu();
    goToShopifyLogin();
  });
  if (loginModal) {
    const closeBtn = loginModal.querySelector('.modal-close');
    closeBtn && closeBtn.addEventListener('click', closeLoginModal);
    loginModal.addEventListener('click', e => { if (e.target === loginModal) closeLoginModal(); });
  }

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      closeLoginModal();
      closeMobileMenu();
      closeMobileSearch();
    }
  });

  /* ────────── ACCORDIONS ────────── */
  document.addEventListener('click', e => {
    const faqQ = e.target.closest('.faq-item');
    if (faqQ) { faqQ.classList.toggle('open'); return; }

    const aboutAcc = e.target.closest('.about-acc-item');
    if (aboutAcc) { aboutAcc.classList.toggle('open'); return; }

    // Policy tabs
    const polTab = e.target.closest('.pol-tab');
    if (polTab) {
      const target = polTab.dataset.policy;
      $$('.pol-tab').forEach(t => t.classList.toggle('active', t === polTab));
      $$('.pol-section').forEach(s => s.classList.toggle('active', s.id === 'pol-' + target));
    }
  });

  /* ────────── FORMS (subscribe / contact / sell — toast feedback) ────────── */
  function wireToastForm(formId, successMsg) {
    const form = $('#' + formId);
    if (!form) return;
    form.addEventListener('submit', e => {
      // Let Shopify handle the actual submission, just show feedback
      const btn = form.querySelector('button[type="submit"]');
      if (btn) {
        const original = btn.textContent;
        btn.textContent = 'Sent ✓';
        setTimeout(() => { btn.textContent = original; }, 2200);
      }
      toast(successMsg);
    });
  }
  wireToastForm('contact-form', "Got it, we'll reply within one business day");
  wireToastForm('sell-form', "Quote request received, we'll reply within 2 business days");

  /* ────────── iOS SAFARI IMAGE RECOVERY ──────────
     Mobile Safari purges image bitmaps from memory when the tab is
     backgrounded or under memory pressure. The <img> tags stay in the
     DOM but render blank. When the tab regains focus, force a re-decode
     by toggling src for any image at/near the viewport. Browser uses
     cached bytes (no network), just re-decodes into memory. */
  function isNearViewport(el) {
    const r = el.getBoundingClientRect();
    const buffer = 500;
    return r.bottom > -buffer && r.top < window.innerHeight + buffer;
  }
  function refreshImages() {
    document.querySelectorAll('img').forEach(img => {
      if (!isNearViewport(img)) return;
      const src = img.currentSrc || img.src;
      if (!src || src.startsWith('data:')) return;
      img.src = '';
      // eslint-disable-next-line no-unused-expressions
      img.offsetHeight;
      img.src = src;
    });
    // Defensive cleanup: clear any leftover inline transform/opacity on tiles
    document.querySelectorAll('.tile').forEach(tile => {
      if (tile.style.opacity || tile.style.transform) {
        tile.style.transform = '';
        tile.style.opacity = '';
        tile.style.transition = '';
      }
    });
  }
  let lastRefresh = 0;
  function maybeRefresh() {
    const now = Date.now();
    if (now - lastRefresh < 800) return;
    lastRefresh = now;
    refreshImages();
  }
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') maybeRefresh();
  });
  window.addEventListener('pageshow', e => {
    if (e.persisted) maybeRefresh();
  });
  window.addEventListener('focus', maybeRefresh);

  /* ────────── MOBILE: TRACK SCROLL POSITION IN PRODUCT ROW ──────────
     As the user horizontally scrolls a product row on mobile, update the
     "X / Y" indicator in the section header to reflect the current tile. */
  function initScrollCounters() {
    const rows = $$('[data-sh-row]');
    rows.forEach(row => {
      const head = row.closest('section') && row.closest('section').previousElementSibling;
      if (!head) return;
      const counter = head.querySelector('[data-sh-count]');
      if (!counter) return;
      const currentEl = counter.querySelector('.sh-count-current');
      if (!currentEl) return;

      function update() {
        const tiles = row.querySelectorAll('.tile');
        if (!tiles.length) return;
        const rowRect = row.getBoundingClientRect();
        const center = rowRect.left + rowRect.width / 2;
        let bestIdx = 0;
        let bestDist = Infinity;
        tiles.forEach((tile, i) => {
          const r = tile.getBoundingClientRect();
          const tileCenter = r.left + r.width / 2;
          const d = Math.abs(tileCenter - center);
          if (d < bestDist) { bestDist = d; bestIdx = i; }
        });
        currentEl.textContent = (bestIdx + 1).toString();
      }

      let raf;
      row.addEventListener('scroll', () => {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(update);
      }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
  initScrollCounters();

  /* ────────── LOAD MORE (collection pages) ────────── */
  function initLoadMore() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-load-more]');
      if (!btn) return;
      e.preventDefault();
      var url = btn.getAttribute('data-next-url');
      if (!url) return;
      btn.disabled = true;
      btn.textContent = 'Loading…';
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-collection-grid]');
          var currentGrid = document.querySelector('[data-collection-grid]');
          if (newGrid && currentGrid) {
            Array.prototype.slice.call(newGrid.children).forEach(function (tile) {
              currentGrid.appendChild(tile);
            });
          }
          var newBtn = doc.querySelector('[data-load-more]');
          if (newBtn) {
            btn.setAttribute('data-next-url', newBtn.getAttribute('data-next-url'));
            btn.disabled = false;
            btn.textContent = 'Load more';
          } else {
            var wrap = btn.closest('.load-more-wrap');
            (wrap || btn).remove();
          }
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = 'Load more';
        });
    });
  }
  initLoadMore();

  /* ────────── INIT: bind add buttons on first paint ────────── */
  bindAddButtons();

  // Expose for sections / re-render scenarios
  window.RareRuns = { addToCart, refreshCart, bindAddButtons, toast };
})();
